import { render } from "./ValidationExplanation.vue?vue&type=template&id=13f780f8&scoped=true"
import script from "./ValidationExplanation.vue?vue&type=script&lang=js"
export * from "./ValidationExplanation.vue?vue&type=script&lang=js"

import "./ValidationExplanation.vue?vue&type=style&index=0&id=13f780f8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f780f8"]])

export default __exports__